export default "__VITE_ASSET__D8t4cDie__"